import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getTransactionHistory } from '../redux/slices/walletSlice';

/**
 * Custom hook for managing transaction history
 * @param {string} coinId - The coin ID
 * @returns {Object} - { transactions, loading, error, pagination, fetchTransactionHistory }
 */
export const useTransactionHistory = (coinId) => {
  const dispatch = useDispatch();
  const mode = useSelector(state => state.mode?.mode || 'public');
  const {
    transactions,
    loading,
    error,
    pagination,
    address,
    chain
  } = useSelector(state => state.wallet.transactionHistory);

  const isPrivateMode = mode === 'private';

  const fetchTransactionHistory = useCallback((page = 1) => {
    if (!coinId) return;

    dispatch(getTransactionHistory({
      coinId,
      mode: isPrivateMode ? 'private' : 'public',
      page,
      limit: 10
    }));
  }, [coinId, isPrivateMode, dispatch]);

  useEffect(() => {
    fetchTransactionHistory();
  }, [fetchTransactionHistory]);

  return {
    transactions,
    loading,
    error,
    pagination,
    fetchTransactionHistory,
    mode,
    address,
    chain
  };
};